import { Mail, Globe, Instagram, Facebook, Send, MessageCircle, Music2, AtSign } from "lucide-react";

export const CONTACT_FIELDS = [
  { key: "email", label: "Contact email", icon: Mail, href: (v) => `mailto:${v}` },
  { key: "instagram", label: "Instagram", icon: Instagram, href: (v) => (v.startsWith("http") ? v : `https://instagram.com/${v.replace(/^@/, "")}`) },
  { key: "tiktok", label: "TikTok", icon: Music2, href: (v) => (v.startsWith("http") ? v : `https://tiktok.com/@${v.replace(/^@/, "")}`) },
  { key: "facebook", label: "Facebook", icon: Facebook, href: (v) => (v.startsWith("http") ? v : `https://facebook.com/${v}`) },
  { key: "x", label: "X (Twitter)", icon: AtSign, href: (v) => (v.startsWith("http") ? v : `https://x.com/${v.replace(/^@/, "")}`) },
  { key: "telegram", label: "Telegram", icon: Send, href: (v) => (v.startsWith("http") ? v : `https://t.me/${v.replace(/^@/, "")}`) },
  { key: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: (v) => (v.startsWith("http") ? v : `https://wa.me/${v.replace(/[^\d]/g, "")}`) },
  { key: "website", label: "Website", icon: Globe, href: (v) => (v.startsWith("http") ? v : `https://${v}`) },
];

export function ContactLinks({ contact }) {
  const items = CONTACT_FIELDS.filter((f) => contact?.[f.key]);
  if (items.length === 0) return null;
  return (
    <div className="mt-10 border-t border-slate-800 pt-6" data-testid="contact-links">
      <p className="eyebrow mb-3">Contact & socials</p>
      <div className="flex flex-wrap gap-2">
        {items.map(({ key, label, icon: Icon, href }) => (
          <a key={key} href={href(contact[key])} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full border border-slate-800 px-3 py-1.5 text-xs text-slate-300 transition-colors hover:border-slate-600 hover:text-white" data-testid={`contact-${key}`}>
            <Icon size={13} /> {key === "email" ? contact[key] : label}
          </a>
        ))}
      </div>
    </div>
  );
}
